export default __webpack_public_path__ + "static/media/5.57a73092.jpeg";